export type AiProviderId = 'doubao' | 'qwen' | 'deepseek' | 'custom';

export type UserAiProfile = {
  id: number;
  label: string;
  ai_provider: AiProviderId | string;
  ai_model: string;
  ai_api_base: string;
  ai_api_key_set: boolean;
  ai_api_key?: string;
  is_default?: boolean;
};

export const AI_PROVIDER_OPTIONS: { id: AiProviderId; label: string; modelHint: string; baseHint: string }[] = [
  { id: 'deepseek', label: 'DeepSeek', modelHint: 'deepseek-chat', baseHint: 'https://api.deepseek.com/v1' },
  { id: 'qwen', label: '通义千问', modelHint: 'qwen-turbo', baseHint: 'https://dashscope.aliyuncs.com/compatible-mode/v1' },
  { id: 'doubao', label: '豆包（火山方舟）', modelHint: '推理接入点 Endpoint ID', baseHint: 'https://ark.cn-beijing.volces.com/api/v3' },
  { id: 'custom', label: '自定义', modelHint: '模型名', baseHint: 'OpenAI 兼容 API 根' },
];

export function aiProviderLabel(id: string): string {
  return AI_PROVIDER_OPTIONS.find((o) => o.id === id)?.label ?? id;
}
